export default {
  loading: 'Cargando secciones',
  section: 'Venta semanal sugerida',
  warningArea: 'Elija un area para continuar.',
  headers: {
    name: 'Nombre',
    section: 'Sección',
    avgWeeklySale: 'Promedio de venta semanal',
    quantity: 'Venta semanal'
  }
}
